import { useEffect, useRef, useState } from "react";
import { VideoSkeleton } from "./Skeleton";

import { useIonRouter, IonIcon } from "@ionic/react";
import { volumeHighOutline, volumeMuteOutline } from "ionicons/icons";

export const LazyVideoPlayer = ({ src, postId, priority }) => {
  const videoContainerRef = useRef(null);
  const videoRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(priority);
  const [isMuted, setIsMuted] = useState(true);
  const router = useIonRouter();

  useEffect(() => {
    // if (priority) return;

    // const observer = new IntersectionObserver(
    //   ([entry]) => entry.isIntersecting && setShouldLoad(true),
    //   { threshold: 0.1, rootMargin: "200px" },
    // );
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // 1. SCROLLED IN: Load the video
          setShouldLoad(true);
        } else {
          // 2. SCROLLED OUT: Mute and Pause (The Facebook behavior)
          if (videoRef.current) {
            videoRef.current.muted = true;
            // videoRef.current.pause(); // Stop playback to save battery
            setIsMuted(true); // Sync the UI icon
          }
        }
      },
      {
        threshold: 0.1, // Trigger as soon as the video is mostly gone
        rootMargin: "0px",
      },
    );
    if (videoContainerRef.current) observer.observe(videoContainerRef.current);
    return () => observer.disconnect();
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    router.push(`/videos?id=${postId}`);
  };

  const handleMuteToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    if (videoRef.current) {
      videoRef.current.muted = newMuted;
    }
  };

  const posterUrl = src.split("?")[0].replace(/\.[^/.]+$/, "") + "-thumb.jpg";

  const getMimeType = (url) => {
    try {
      const cleanUrl = url.split("?")[0];
      const extension = cleanUrl.split(".").pop().toLowerCase();
      if (extension === "mov") {
        return "video/quicktime";
      }
      return `video/${extension}`;
    } catch (e) {
      return "video/mp4";
    }
  };

  return (
    <div ref={videoContainerRef} style={{ position: "relative" }}>
      {shouldLoad ? (
        <>
          <video
            className="post-video"
            ref={videoRef}
            preload={priority ? "metadata" : "none"}
            playsInline
            disablePictureInPicture
            autoPlay
            muted={isMuted}
            loop
            poster={posterUrl}
            style={{ width: "100%", display: "block" }}
            onClick={handleClick}
          >
            <source src={src} type={getMimeType(src)} />
          </video>
          <div
            onClick={handleMuteToggle}
            className="swiper-no-swiping"
            style={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
              zIndex: 9999, // Ensure it's astronomically high
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              pointerEvents: "auto",
              touchAction: "manipulation",
              WebkitTransform: "translate3d(0, 0, 10px)",
              transform: "translate3d(0, 0, 10px)",
              WebkitBackfaceVisibility: "hidden",
              isolation: "isolate",
            }}
          >
            <IonIcon
              icon={isMuted ? volumeMuteOutline : volumeHighOutline}
              style={{
                color: "#ffffff",
                fontSize: "20px",
                opacity: "1",
                display: "block", // Ensure it's not collapsed
              }}
            />
          </div>
        </>
      ) : (
        <VideoSkeleton />
      )}
    </div>
  );
};
